"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OutletSearch_1 = require("./OutletSearch");
var OutletSearchStore = require("../../store/OutletSearchStore");
var react_redux_1 = require("react-redux");
require("./OutletSearch.css");
require("bootstrap/dist/css/bootstrap.css");
var OutletSearchSetWrapper = /** @class */ (function (_super) {
    __extends(OutletSearchSetWrapper, _super);
    function OutletSearchSetWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            formErrors: '',
            searchString: '',
            venues: [],
            required: false,
            display: true,
        };
        _this.onClickSearchFields = _this.onClickSearchFields.bind(_this);
        _this.onClickClearSearchFields = _this.onClickClearSearchFields.bind(_this);
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.inpName = React.createRef();
        _this.inpAddress = React.createRef();
        _this.inpSuburb = React.createRef();
        _this.inpState = React.createRef();
        _this.inpPostcode = React.createRef();
        _this.inpPhone = React.createRef();
        return _this;
    }
    OutletSearchSetWrapper.prototype.onChangeHandler = function () {
        this.setState({ display: true });
        this.onClickSearchFields();
    };
    ;
    OutletSearchSetWrapper.prototype.onClickClearSearchFields = function () {
        this.inpName.current.value = '';
        this.inpAddress.current.value = '';
        this.inpSuburb.current.value = '';
        this.inpState.current.value = '';
        this.inpPostcode.current.value = '';
        this.inpPhone.current.value = '';
        this.setState({ required: false });
        this.setState({ venues: [] });
        this.setState({ display: false });
    };
    OutletSearchSetWrapper.prototype.onClickSearchFields = function () {
        this.setState({ display: true });
        this.setState({ required: false });
        var searchString = "";
        if (this.inpName.current.value !== '')
            searchString = searchString + "outletname=" + this.inpName.current.value + "|";
        if (this.inpAddress.current.value !== '')
            searchString = searchString + "address=" + this.inpAddress.current.value + "|";
        if (this.inpSuburb.current.value !== '')
            searchString = searchString + "suburb=" + this.inpSuburb.current.value + "|";
        if (this.inpState.current.value !== '')
            searchString = searchString + "state=" + this.inpState.current.value + "|";
        if (this.inpPostcode.current.value !== '')
            searchString = searchString + "postcode=" + this.inpPostcode.current.value + "|";
        if (this.inpPhone.current.value !== '')
            searchString = searchString + "phone=" + this.inpPhone.current.value + "|";
        if (searchString === '')
            this.setState({ required: true });
        this.props.requestOutletSearch(searchString);
    };
    OutletSearchSetWrapper.prototype.render = function () {
        var venues = this.props.venues;
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", null, "Outlet Search "),
            React.createElement("div", null,
                React.createElement("div", { className: "row-box" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-12 col-md-3 col-lg-3 " },
                            React.createElement("label", { ref: "VenueName", className: "font-weight-bold" }, " Venue Name "),
                            React.createElement("input", { ref: this.inpName, className: "form-control mr-sm-2", type: "search", onChange: this.onChangeHandler, placeholder: "Search Venue Name", "aria-label": "Search Venue" })),
                        React.createElement("div", { className: "col-xs-12 col-md-3 col-lg-3 " },
                            React.createElement("label", { className: "font-weight-bold" }, " Address "),
                            React.createElement("input", { ref: this.inpAddress, className: "form-control mr-sm-2", type: "search", onChange: this.onChangeHandler, placeholder: "Search Address", "aria-label": "Search Venue" })),
                        React.createElement("div", { className: "col-xs-12 col-md-3 col-lg-3" },
                            React.createElement("label", { className: "font-weight-bold" }, " Suburb "),
                            React.createElement("input", { ref: this.inpSuburb, className: "form-control mr-sm-2", type: "search", onChange: this.onChangeHandler, placeholder: "Search Suburb", "aria-label": "Search Venue" }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-12 col-md-3 col-lg-3 " },
                            React.createElement("label", { className: "font-weight-bold" }, " State "),
                            React.createElement("input", { ref: this.inpState, className: "form-control mr-sm-2", type: "search", onChange: this.onChangeHandler, placeholder: "Search State", "aria-label": "Search Venue", name: "SearchString" })),
                        React.createElement("div", { className: "col-xs-12 col-md-3 col-lg-3 " },
                            React.createElement("label", { className: "font-weight-bold" }, " Postcode "),
                            React.createElement("input", { ref: this.inpPostcode, className: "form-control mr-sm-2", type: "search", onChange: this.onChangeHandler, placeholder: "Search Postcode", "aria-label": "Search Venue", name: "SearchString" })),
                        React.createElement("div", { className: "col-xs-12 col-md-3 col-lg-3 " },
                            React.createElement("label", { className: "font-weight-bold" }, " Phone Number "),
                            React.createElement("input", { ref: this.inpPhone, className: "form-control mr-sm-2", type: "search", onChange: this.onChangeHandler, placeholder: "Search Phone", "aria-label": "Search Venue", name: "SearchString" })))),
                React.createElement("div", { className: "btn-toolbar float-right" },
                    React.createElement("button", { type: "button", className: "btn btn-secondary mr-3 active float-right", onClick: this.onClickClearSearchFields }, " New Search "),
                    React.createElement("button", { type: "button", className: "btn btn-info btn active float-right", onClick: this.onClickSearchFields }, " Search "))),
            React.createElement("br", null),
            this.state.required === false && this.state.display === true && (React.createElement("div", null,
                React.createElement(OutletSearch_1.default, { venues: venues }))),
            React.createElement("br", null),
            this.searchFieldValidate()));
    };
    OutletSearchSetWrapper.prototype.searchFieldValidate = function () {
        return (React.createElement("div", null, this.state.required === true && (React.createElement("h5", null, "Please Select one search criteria."))));
    };
    return OutletSearchSetWrapper;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.outletSearch; }, // Selects which state properties are merged into the component's props
OutletSearchStore.actionCreators // Selects which action creators are merged into the component's props
)(OutletSearchSetWrapper);
//# sourceMappingURL=OutletSearchSetWrapper.js.map